import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

/**
 * Application footer component.
 *
 * @remarks Provides the main site footer with navigation links, legal information,
 * and company details. Typically displayed at the bottom of all pages to ensure
 * consistent site-wide footer content and navigation options.
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class FooterComponent {}
